import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Area } from "types";
import { join } from "utils/misc";

type Props = {
  creatorId?: number | null;
};

const CreatorLabel: React.VFC<Props> = ({ creatorId }) => {
  const { t } = useTranslation();

  if (creatorId != null) {
    return <Link to={join(Area.Therapists, creatorId)}>{t("creator.pt_label", { id: creatorId })}</Link>;
  }

  return <>{t("creator.joint_academy")}</>;
};

export default CreatorLabel;
